<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'

   export default {
      page: {
         title: "Leaves",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Leaves",
            items: [
               {
                  text: "Doctors",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',
            status: '',
            schedule_from_date:'',
            schedule_date:'',
            from_date:'',
            to_date:'',
            upcoming: [],
            history: [],
            leave_status: {
               id: "",
            },
         };
      },
      created() {
         this.fetchUpcoming();
         this.fetchHistory();
      },

      mounted() {
    
      },

      methods:{
         fetchUpcoming(page_url = null) {

            this.getToken();
            let url = "clinic/doctors/upcomingLeaves?doctor_id=" +  this.$route.params.id + "&from_date=" + this.schedule_from_date + "&to_date=" + this.schedule_date;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.upcoming = responseData.leaves;
                  this.setTime(1);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 
         fetchHistory(page_url = null) {

            this.getToken();
            let url = "clinic/doctors/leaveHistory?doctor_id=" +  this.$route.params.id + "&from_date=" + this.from_date + "&to_date=" + this.to_date;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.history = responseData.leaves;
                  this.setTime(2);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
            }, 

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
         setTime(type) {
            var sessions;
            var schedules = [];
            if(type==1){
               sessions = this.upcoming;
            }else{
               sessions = this.history;
            }
            sessions.forEach(obj => {

               var session = {};
               session.start = obj.start_time;
               session.end = obj.end_time;
               session.session_id = obj.id;
               session.day = obj.day_id;
               session.duration = obj.duration;
               session.token_type = obj.token_type;
               session.clinic_name = obj.clinic_name;
               session.fee = obj.consultation_fee;

               var schedule = {};
               schedule.day = obj.day_id;               
               schedule.start = moment.utc('2002-02-02 ' + obj.start_time).format('hh:mm A');
               schedule.end = moment.utc('2002-02-02 ' + obj.end_time).format('hh:mm A');
               schedule.duration = obj.duration;
               schedule.token_type = obj.token_type;
               schedule.clinic_id = obj.clinic_id;
               schedule.clinic_name = obj.clinic_name;
               schedule.consultation_fee = obj.consultation_fee;
               schedule.date = obj.date;
               schedule.consultation_type= obj.consultation_type;
               schedule.doctor_edit_id= obj.doctor_edit_id;

               var set_time = obj.duration;
               var hour = set_time.split(':')[0];
               var minutes = set_time.split(':')[1];
               if(hour!='00'){
                  schedule.time_name = hour+' Hr '+ minutes +' min ';
               }else{
                  schedule.time_name =  minutes +' min ';
               }
               // schedule.clinic_name = obj.clinic_name;
               schedules.push(schedule); 

            });
            if(type==1){
               this.upcoming = schedules;
            }else{
               this.history = schedules;
            }
         }, 
         // unmarkLeave(id) {
         //    this.deactivate = false;
         //      this.$bvModal.msgBoxConfirm('Are you sure you want unmark leave?', {
         //          title: 'Mark Leave?',
         //          size: 'sm',
         //          buttonSize: 'sm',
         //          okVariant: 'danger',
         //          okTitle: 'Yes',
         //          cancelTitle: 'No',
         //          footerClass: 'p-2',
         //          hideHeaderClose: false,
         //          centered: true
         //      })
         //       .then(value =>{
         //          this.deactivate = value
         //          console.log(value);
         //          if(this.deactivate){
         //             this.leave_status.id = id;
         //             this.updateLeaveStatus();
         //          }
         //       })
         //       .catch(err => {
         //          console.log(err);
         //       })
         // },
         // updateLeaveStatus() {
            
         //    this.getToken();
         //    const config = {
         //       headers: {
         //          "Content-type": "application/json",
         //          "Accept": "application/json",
         //          "Authorization": "Bearer " + this.token,
         //       },
         //    };
         //    let url = "clinic/doctors/unmarkLeave?doctor_edit_id=" + this.leave_status.id ;
         //    this.$axios
         //       .get(url, config)
         //       .then((response) => {                  
         //          if (response.data.status) {
         //             this.$swal("", response.data.message, "success");
         //          } else {
         //             this.$swal("", response.data.message, "error");
         //          }
         //          this.fetchUpcoming();
         //       })
         //       .catch((error) => {                
         //          if (error.response) {
         //             if (error.response.data.message) {
         //                this.$swal("", error.response.data.message, "error");
         //             } else {
         //                this.$swal("", "Something went wrong", "error");
         //             }
         //          } else {
         //             this.$swal("", "Something went wrong", "error");
         //          }
         //       });
         // }, 

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="row">
                     <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
            <b-tab active>
            <template v-slot:title>
         
             <span class="">Upcoming Leaves</span>
            </template>
            <!-- <b-card header-class="bg-transparent border-light" class="border border-light" v-if="add"> -->
            <div class="card">
               <div class="card-body">
                  <!----- filters area starts---->
                  <div class="row">
                     <div class="form-group col-md-4">
                        <label>From Date <span class="text-danger">*</span></label>
                        <input type="date" class="form-control" v-model="schedule_from_date" />
                     </div>  
                     <div class="form-group col-md-4">
                        <label>To Date <span class="text-danger">*</span></label>
                        <input type="date" class="form-control" v-model="schedule_date"  />
                     </div> 
                     <div class="col-md-4 d-flex align-items-center">
                        <span class="ms-2">
                           <b-button  variant="primary" @click="fetchUpcoming()" class="btn-sm" >View</b-button>
                        </span>
                     </div>
                      
                  </div>
                 
               </div>
            </div>
            <div v-for="(upcomin, index) in upcoming" :key="index">
               <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                             
                              <div class="media-body">
                                 <h4><p class="text-muted fw-medium mb-2">{{upcomin.date|formatDate}}</p></h4>
                                 <span class="mb-0">Time: {{ upcomin.start| formatTime }} - {{ upcomin.end| formatTime }} | {{upcomin.time_name}}
                                    <!-- <b-button  variant="danger" class="btn-sm float-end ms-2" @click="unmarkLeave(upcomin.doctor_edit_id)">Unmark Leave</b-button> -->
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="upcomin.consultation_type==1">Video Visit</span>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="upcomin.consultation_type==2">Home Visit</span>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="upcomin.consultation_type==3">Clinic Visit</span>
                                 </span>
                                 
                              </div>                              
                           </div>
               </b-card> 
            </div>
            </b-tab>

            <b-tab>
         
               <template v-slot:title>
         
         <span class="">Leave History</span>
        </template>
        <!-- <b-card header-class="bg-transparent border-light" class="border border-light" v-if="add"> -->
            <div class="card">
                  <div class="card-body">
                     <!----- filters area starts---->
                     <div class="row">
                        <div class="form-group col-md-4">
                           <label>From Date <span class="text-danger">*</span></label>
                           <input type="date" class="form-control" v-model="from_date"/>
                        </div>  
                        <div class="form-group col-md-4">
                           <label>To Date <span class="text-danger">*</span></label>
                           <input type="date" class="form-control" v-model="to_date"/>
                        </div> 
                        <div class="col-md-4 d-flex align-items-center">
                           <span class="ms-2">
                              <b-button  variant="primary" class="btn-sm" @click="fetchHistory()">View</b-button>
                           </span>
                        </div>
                        
                     </div>
                  
                  </div>
            </div>
            <div v-for="(histo, index) in history" :key="index">
               <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              
                              <div class="media-body">
                                 <h4><p class="text-muted fw-medium mb-2">{{histo.date |formatDate}}</p></h4>
                                 <span class="mb-0">Time: {{ histo.start| formatTime }} - {{ histo.end| formatTime }} | {{histo.time_name}}
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="histo.consultation_type==1">Video Visit</span>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="histo.consultation_type==2">Home Visit</span>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="histo.consultation_type==3">Clinic Visit</span>                                 </span>
                                 
                              </div>                              
                           </div>
               </b-card>
            </div> 
       
                        
          
            </b-tab>
            
            </b-tabs>
               

                     </div>
         </div>
      </div>
   </Layout>
</template>
